<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style scoped>

.banner-wrap {
  border: 1px solid #dfdfdf !important;
}

.border-right-1 {
  position: relative;
  border-right: 1px solid #cbcbcb;
}

@media screen and (min-width: 1367px) and (max-width: 1440px) {
  .vue-form-wizard .wizard-tab-content {
    padding: 0px 80px 10px !important;
  }
  p.reco-text{font-size: 11px; margin-top: 5px;}
}
@media screen and (max-width: 1366px) {
  .vue-form-wizard .wizard-tab-content {
    padding: 0px 20px 10px !important;
  }
  p.reco-text{font-size: 11px; margin-top: 5px;}
}
</style>
<template>
  <div class="event-edit-wrapper">
    <div class>
      <div class="header-custome">
        <h3>Event Setup</h3>
        <!--<div class="knowlg-base-wrap-sec">
          <a href="/pages/knowledge-base/category-eventdashboard/question-2">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-help-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </span>
            Need help with this section?
          </a>
        </div>-->
      </div>
    </div>

    <vx-card title title-color subtitle>
      <form-wizard
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        nextButtonText="Save & Continue"
        finishButtonText="Submit"
        @on-complete="formSubmittedt3"
        v-if="EventData"
        layout="vertical"
        steps-classes="stepSize"
        ref="forwizard"
      >
        <tab-content
          title="Event Info"
          class="mb-5"
          :before-change="before_save"
          icon="feather icon-info"
        >
          <!-- tab 1 content -->
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-6">
              <div class="custom-head-wrap">
                <h2 class="cms-custom-heading">Basic Info</h2>
                <p class="mt-1 mb-0">
                  Name your event, when your event starts and ends, venue of
                  your event.
                </p>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full md:mt-8 name-evnt">
              <label>Event Name</label>
              <vs-input
                class="w-full"
                v-validate="'required'"
                name="Event Full Name"
                v-model="EventData.EventFullName"
                tabindex="1"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Event Full Name')"
                >{{ errors.first("Event Full Name") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full md:mt-8">
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" >
                  <label class="type-evnt-lbl">Event Start Date</label>
                  <flat-pickr
                    :disabled="DateDisabled"
                    :config="configdateTimePickerStart"
                    placeholder="Start Date"
                    v-validate="'required'"
                    name="Event Start Date"
                    v-model="EventData.EventStartDate"
                    class="time-pkr w-full"
                    tabindex="2"    
                    
                  ></flat-pickr>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('Event Start Date')"
                    >{{ errors.first("Event Start Date") }}</span
                  >
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <label class="type-evnt-lbl">Event End Date</label>
                  <flat-pickr
                    :disabled="DateDisabled"
                    :config="configdateTimePickerEnd"
                    placeholder="End Date"
                    v-validate="'required'"
                    name="Event End Date"
                    v-model="EventData.EventEndDate"
                    class="time-pkr w-full"
                  ></flat-pickr>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('Event End Date')"
                    >{{ errors.first("Event End Date") }}</span
                  >
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-6/12 w-full mt-4">
              <label>Time Zone</label>
              <vs-select
                v-model="EventData.TimeZone"
                class="w-full select-large"
                :options="tzStrings"
                :disabled="DateDisabled"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.label"
                  v-for="(item, index) in tzStrings"
                  class="w-full"
                />
              </vs-select>
            </div>

            <div class="vx-col lg:w-6/12 md:w-6/12 w-full mt-4">
              <label>Default Event Language</label>
              <div class="w-full">
                <v-select
                  class=""
                  :options="['Engilsh', 'German', 'French', 'Mandarin']"
                  v-model="EventData.DefaultLanguage"
                />
              </div>
            </div>

            <div class="vx-col sm:w-12/12 w-full mt-4">
              <div class="vx-row">
                <div class="vx-col sm:w-6/12 w-full">
                  <label class="type-evnt-lbl edit-eve labl-head">
                    <span>Event Access</span>
                    <span class="event-access-info">
                      <feather-icon class="ml-2" icon="InfoIcon" title />
                      <div class="event-type-head-tooltip">
                        <p class="mb-0">
                          <strong>Public:</strong>
                        </p>
                        <p>
                          Anyone can discover and register for a Public event
                          (they will be indexed by search engines).
                        </p>
                        <p class="mb-0">
                          <strong>Private:</strong>
                        </p>
                        <p>
                          Events which do not require self registration. Event
                          planners send invitation and login info to join the
                          event.
                        </p>
                      </div>
                    </span>
                  </label>
                  <div class="w-full flex items-center mt-2">
                    <vs-radio v-model="EventData.EventType" vs-value="2"
                      >Public</vs-radio
                    >
                    <vs-radio
                      class="ml-3"
                      v-model="EventData.EventType"
                      vs-value="1"
                      >Private</vs-radio
                    >


                    <div
                      v-show="EventData.EventType == 2"
                    >
                      <div class=" ml-5">
                        <!--<label class="type-evnt-lbl">Allow Registration</label>-->
                        <div class="w-full">
                          <vs-checkbox v-model="EventData.AllowRegistration"
                            >Allow Registration</vs-checkbox
                          >
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>

                <div
                  class="vx-col sm:w-3/12 w-full"
                  v-show="EventData.AllowRegistration"
                >
                  <label>External Registration Enabled</label>
                  <vs-switch
                    class="mt-4"
                    v-model="EventData.ExternalRegistrationEnabled"
                  />
                </div>

                <div
                  class="vx-col sm:w-3/12 w-full"
                  v-show="EventData.AllowRegistration && EventData.ExternalRegistrationEnabled"
                >
                  <label>External Registration Link</label>
                  <vs-input
                    class="w-full"
                    v-model="EventData.ExternalRegistrationLink"                    
                  />
                </div>
                
                <div
                  class="vx-col sm:w-3/12 w-full"
                  v-show="ClientDetails && ClientDetails.crm_integration && ClientDetails.crm_integration.IsPublished"
                >
                  <label>CRM Integration</label>
                  <vs-switch
                    class="mt-4"
                    @click="checkCRMDisable"
                    v-model="EventData.postToCRM"
                  />
                </div>                
              </div>
            </div>

            <div class="vx-col lg:w-6/12 md:w-6/12 w-full mt-4">
              <label>
                <span>Login Authentication</span>
              </label>
              <div class="w-full">
                <v-select
                  class="w-full select-large"
                  v-model="EventData.EventAccessType"
                  :options="[
                    'Unique Passcode per Attendee',
                    'Use Common Event Passcode',
                  ]"
                />
              </div>
            </div>
            <div
              class="vx-col lg:w-3/12 md:w-6/12 w-full mt-4"
              v-show="EventData.EventAccessType == 'Use Common Event Passcode'"
            >
              <div class="w-full">
                <label>Default Passcode</label>
                <vs-input
                  class="w-full"
                  name="Default Passcode"
                  v-model="EventData.defaultEP"
                  v-validate="
                    EventData.EventAccessType == 'Use Common Event Passcode'
                      ? 'required'
                      : ''
                  "
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Default Passcode')"
                  >{{ errors.first("Default Passcode") }}</span
                >
              </div>
            </div>
            <div class="vx-col lg:w-3/12 md:w-6/12 w-full mt-4">
              <label>Default Streaming Client</label>
              <div class="w-full mt-5">
                <vs-radio
                  v-model="EventData.StreamingClient"
                  vs-value="Web"
                  name="StreamingClient"
                  >Web</vs-radio
                >
                <vs-radio
                  class="ml-3"
                  v-model="EventData.StreamingClient"
                  vs-value="Zoom"
                  name="StreamingClient"
                  >Zoom Client</vs-radio
                >
                <vs-radio
                  class="ml-3"
                  v-model="EventData.StreamingClient"
                  vs-value="ZoomWeb"
                  name="StreamingClient"
                  >Zoom Web</vs-radio
                >
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-2" v-if="EventData.StreamingClient.includes('Zoom')">
              <label>Approval Type</label>
                <v-select
                  class="mt-3"
                  label="Name"
                  :clearable="false"
                  :options="[
                    {Name:'Open Meeting', id:2},
                    //{Name:'Need Approval', id:1},
                    {Name:'Need Registration', id:0}
                  ]"
                  :reduce="(option) => option.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="EventData.approval_type"
                />
            </div>

          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-3">
              <label>Event Type</label>
              <v-select
                class="w-full select-large"
                label="Name"
                v-model="EventData.LocationType"
                :options="locationOptions"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-3">
              <label>Default Landing Page</label>
              <v-select
                class="w-full select-large"
                v-model="EventData.DefaultLandingURL"
                :options="landingURLOptions"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 name-evnt mt-3 d-none">
              <vs-input
                v-show="EventData.LocationType.Name != 'Virtual'"
                class="w-full"
                label="Location"
                v-model="EventData.Venue"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2" style="display:none">
                <vs-input
                  class="w-full"
                  label="Meta Title"
                  v-model="EventData.MetaTitle"
                />
            </div>



            <div class="vx-col md:w-1/2 w-full mt-2" style="display:none">
                <vs-input
                  class="w-full"
                  label="Meta Description"
                  v-model="EventData.MetaDescription"
                />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2" style="display:none">
                <vs-input
                  class="w-full"
                  label="Meta Keywords"
                  v-model="EventData.MetaKeywords"
                />
            </div>
            <div class="vx-col md:w-1/2 w-full mt-4" style="display:none">
              <label>Meta Image</label>
              <div class="flex flex-wrap items-center justify-start">
                <img v-if="EventData.MetaImage" :src="EventData.MetaImage" class="mr-8 rounded h-24 w-24" />
                <vs-input
                  class="w-full"
                  type="file"
                  @change="update_metaimage"
                  accept="image/*"
                />
              </div>        
            </div>
            <!--
        <div class="vx-col w-full mt-4">
          <GmapMap
            :center="center"
            :zoom="7"
            map-type-id="terrain"
            style="width: 100%; height: 400px"
            @click="mapClicked"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center=m.position"
            />
          </GmapMap>
        </div>
            -->
          </div>

          <div class="vx-row" id="apply_theme">
            <div class="vx-col md:w-1/1 w-full">
              <div class="custom-head-wrap"> 
                <h2 class="cms-custom-heading">Advanced Settings 
                  <feather-icon icon="ChevronDownIcon" class="cursor-pointer ml-5" v-show="!show_adv_settings" @click="show_adv_settings = show_adv_settings ? false : true" />
                  <feather-icon icon="ChevronUpIcon" class="cursor-pointer ml-5" v-show="show_adv_settings" @click="show_adv_settings = show_adv_settings ? false : true" />
                </h2>
              </div>
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Hide Event Header And Menu</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.HideEventHeaderAndMenu"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Enable Email Only Login</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.EnableEmailOnlyLogin"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Allow Public Access</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.AllowPublicAccess"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Registration Form Version</label>
              <vs-input-number
                class="mt-4"
                min="1"
                v-model="EventData.RegistrationVersion"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Show Profile Edit On Welcome</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.ShowProfileEditOnWelcome"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Allow Profile Edit</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.AllowProfileEdit"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Show Attendee Presence Bubble</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.showAttendeePresenceBubble"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Welcome Message</label>
              <vs-input
                class="mt-4 w-full"
                v-model="EventData.WelcomeMessage"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Disable Language Option</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.DisableLanguageOption"
              />
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Logout Redirect URL</label>
              <vs-input
                class="mt-4 w-full"
                v-model="EventData.LogoutRedirectURL"
                name="Logout Redirect URL"
                v-validate="{url: {require_protocol: true }}"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Logout Redirect URL')"
                >{{ errors.first("Logout Redirect URL") }}</span
              >
            </div>
            <div
              v-show="show_adv_settings"
              class="vx-col sm:w-3/12 w-full mt-4"          
            >
              <label>Disable Language Option</label>
              <vs-switch
                class="mt-4"
                v-model="EventData.DisableLanguageOption"
              />
            </div>
            
          </div>

          <div class="vx-row" id="apply_theme">
            <div class="vx-col md:w-1/1 w-full mb-6 mt-6">
              <div class="custom-head-wrap">
                <h2 class="cms-custom-heading">Apply Theme</h2>
                <p class="mt-1 mb-0">
                  Use this section to customize the event, colours, background
                  and banners for sponsorship and more.
                </p>
              </div>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-3 text-center">
              <div class="default-theme-wrapper">
                <div class="radio-wrapper">
                  <vs-radio
                    v-model="BrandingJson.appColorHexCodeType"
                    vs-value="headerColorsHexCodeLight"
                    >Default</vs-radio
                  >
                  <div class="theme-info-area">
                    <feather-icon
                      class="ml-2 info-ico-i"
                      icon="InfoIcon"
                      title
                    />
                    <div class="theme-thumbnail-tooltip">
                      <div class="thumb-image-wrapper">
                        <img src="../../assets/images/default-theme.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-3 text-center">
              <div class="default-theme-wrapper dark-theme-wrapper">
                <div class="radio-wrapper">
                  <vs-radio
                    class="ml-3"
                    v-model="BrandingJson.appColorHexCodeType"
                    vs-value="headerColorsHexCodeDark"
                    >Dark</vs-radio
                  >
                  <div class="theme-info-area">
                    <feather-icon
                      class="ml-2 info-ico-i"
                      icon="InfoIcon"
                      title
                    />
                    <div class="theme-thumbnail-tooltip">
                      <div class="thumb-image-wrapper">
                        <img src="../../assets/images/dark-theme.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-3 text-center">
              <div class="w-full">
                <vs-checkbox v-model="BrandingJson.uploadCustomLogoAndBanner"
                  >Upload Custom Logo &amp; Banner</vs-checkbox
                >
              </div>
            </div>
            <!--<div class="vx-col md:w-1/3 w-full mt-3 text-center">
              <vs-radio
              v-if="PlanDetails.ShowBrandingEventSetup"
              class="ml-3"
              v-model="BrandingJson.appColorHexCodeType"
              vs-value="headerColorsHexCodeCustom"
            >Custom</vs-radio>
            </div>-->
          </div>
          <!--<div class="vx-col sm:w-1/1 w-full mt-8">
            <div class="type-evnt">
              <h4>Event Theme</h4>
              <div class="w-full mt-2">
                <vs-radio
                  v-model="BrandingJson.appColorHexCodeType"
                  vs-value="headerColorsHexCodeLight"
                >Light</vs-radio>
                <vs-radio
                  class="ml-3"
                  v-model="BrandingJson.appColorHexCodeType"
                  vs-value="headerColorsHexCodeDark"
                >Dark</vs-radio>
                <vs-radio
                  v-if="PlanDetails.ShowBrandingEventSetup"
                  class="ml-3"
                  v-model="BrandingJson.appColorHexCodeType"
                  vs-value="headerColorsHexCodeCustom"
                >Custom</vs-radio>
              </div>
            </div>
          </div>-->

          <div
            class="vx-row"
            v-show="BrandingJson.uploadCustomLogoAndBanner == true"
          >
            <div class="vx-col md:w-1/2 w-full mt-8 banner-single-wrap">
              <div class="vx-row">                
                <div class="vx-col md:w-1/2 event-icon-upload banner-wrap mt-4">
                  <h4>Upload Logo</h4>
                  <div class="logo-wrap-hld single-banner" style="height: 84px">
                    <img
                      v-if="BrandingJson['eventLogo']['960x192']"
                      :src="BrandingJson['eventLogo']['960x192']"
                    />
                    <span class="img-delete-butn">
                      <button
                        @click="
                          deleteBrandingJson($event, '960x192', 'eventLogo')
                        "
                      >
                        <img src="../../assets/images/btn-del.png" />
                      </button>
                    </span>
                  </div>
                  <div class="event-edit-choose-file-area">
                    <input
                      type="file"
                      @change="
                        uploadBrandingJson($event, '960x192', 'eventLogo', '5/1')
                      "
                      accept="image/*"
                    />
                    <div class="image-specification">
                      <p>
                        <strong>Image Specification</strong>
                      </p>
                      <p>
                        Supported image formats: jpeg, png and recommended image
                        dimension 960/192
                      </p>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 event-icon-upload banner-wrap mt-4">
                  <h4>Upload Social Sharing</h4>
                  <div class="logo-wrap-hld single-banner" style="height: 84px">
                    <img
                      v-if="BrandingJson['ogImage'] && BrandingJson['ogImage']['1200x628']"
                      :src="BrandingJson['ogImage']['1200x628']"
                    />
                    <span class="img-delete-butn">
                      <button
                        @click="
                          deleteBrandingJson($event, '1200x628', 'ogImage')
                        "
                      >
                        <img src="../../assets/images/btn-del.png" />
                      </button>
                    </span>
                  </div>
                  <div class="event-edit-choose-file-area">
                    <input
                      type="file"
                      @change="
                        uploadBrandingJson($event, '1200x628', 'ogImage', '2/1')
                      "
                      accept="image/*"
                    />
                    <div class="image-specification">
                      <p>
                        <strong>Image Specification</strong>
                      </p>
                      <p>
                        Supported image formats: jpeg, png and recommended image
                        dimension 1200/628
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5">
                <h4>Upload Banner</h4>
                <div class="event-icon-upload banner-wrap mt-4">
                  <div class="logo-wrap-hld single-banner" style="height: 84px">
                    <img
                      v-if="BrandingJson['banner']['2048x88']"
                      :src="BrandingJson['banner']['2048x88']"
                    />
                    <span class="img-delete-butn">
                      <button
                        @click="deleteBrandingJson($event, '2048x88', 'banner')"
                      >
                        <img src="../../assets/images/btn-del.png" />
                      </button>
                    </span>
                  </div>

                  <div class="event-edit-choose-file-area">
                    <input
                      type="file"
                      @change="
                        uploadBrandingJson(
                          $event,
                          '2048x88',
                          'banner',
                          '256/11'
                        )
                      "
                      accept="image/*"
                    />
                    <div class="image-specification">
                      <p>
                        <strong>Image Specification</strong>
                      </p>
                      <p>
                        Supported image formats: jpeg, png and recommended image
                        dimension 2048/88
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-8">
              <h4 class="choose-color-head">Background</h4>
              <div class="vx-row">
                <div class="vx-col md:w-1/2">
                  <div class="single-color-bar">
                    <label style="width: 100%">Background Color</label>
                    <input v-model="EventData.BackgroundColor" type="color" />
                  </div>
                </div>
                <div class="vx-col md:w-1/2">
                  <div class="single-color-bar">
                    <label style="width: 100%">Body Text Color</label>
                    <input v-model="EventData.BodyTextColor" type="color" />
                  </div>
                </div>
              </div>
              <!--<div class="demo-alignment image-opt mt-5">
            <span>Or select a background image:</span>
              <div class="mt-4">
                <vs-switch v-model="EventData.UseBackgroundImage" name="UseBackgroundImage">
                <span slot="true">True</span>
                <span slot="false">False</span>
              </vs-switch>
            </div>
              </div>-->
              <label>Or choose a background image</label>
              <div class="event-icon-upload banner-wrap">
                <div
                  class="logo-wrap-hld single-banner back-image-banner"
                  style="height: 250px"
                >
                  <img
                    v-if="BrandingJson['eventBGImage']['2732x2048']"
                    :src="BrandingJson['eventBGImage']['2732x2048']"
                  />
                  <span class="img-delete-butn">
                    <button
                      @click="
                        deleteBrandingJson($event, '2732x2048', 'eventBGImage')
                      "
                    >
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="event-edit-choose-file-area">
                  <input
                    type="file"
                    @change="
                      uploadBrandingJson(
                        $event,
                        '2732x2048',
                        'eventBGImage',
                        '683/512'
                      )
                    "
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>
                      Supported image formats: jpeg, png and recommended image
                      dimension 2732/2048
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-6 mt-8">
              <div class="custom-head-wrap">
                <h2 class="cms-custom-heading">Description</h2>
                <p class="mt-1 mb-0">
                  You can add Description of the session with info about the
                  event, agenda, speakers and any other information. Add details
                  that highlight what makes your event unique and why they
                  should come.
                </p>
              </div>
            </div>
            <div class="vx-col md:w-1/1 w-full mt-8 position-relative">
              <div class="mail-tmplt-btns">
                <div class="tmplt-btn-wrap new-edit-template">
                  <a
                    class="right-off-radius"
                    @click="showRawHtml = showRawHtml ? false : true"
                    >{{ showRawHtml ? "Editor" : "HTML Code" }}</a
                  >
                </div>
              </div>
              <div class="profile-edit w-full">
                <!-- <quill-editor
                  v-if="!showRawHtml"
                  v-model="EventData.Description"
                  class="desc-event"
                /> -->
                <ckeditor
                  class="desc-event w-full"
                  v-if="!showRawHtml"
                  v-model="EventData.Description"
                  :config="editorConfig"
                ></ckeditor>
                <vs-textarea
                  v-if="showRawHtml"
                  v-model="EventData.Description"
                  class="inputx w-full"
                  rows="10"
                  cols="100"
                />
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-6 mt-8">
              <div class="custom-head-wrap">
                <h2 class="cms-custom-heading">Event Host</h2>
                <p class="mt-1 mb-0">
                  Use this section to highlight organizer details in
                  registration landing page and event lobby(standard).
                </p>
              </div>
            </div>
            <div class="vx-col md:w-1/1 w-full">
              <div class="host-section">
                <div class="vx-row">
                  <div class="vx-col md:w-4/12 w-full border-right-1">
                    <div class="host-logo event-edit-host">
                      <div class="host-logo-wrap">
                        <!--<img
                          src="https://image.shutterstock.com/image-vector/initial-logo-icon-web-hosting-260nw-1195698478.jpg"
                        />-->

                        <img
                          v-if="
                            BrandingJson['HostInfo'] &&
                            BrandingJson['HostInfo']['Logo']
                          "
                          :src="BrandingJson['HostInfo']['Logo']"
                        />
                        <input
                          id="fuHostLogo"
                          type="file"
                          @change="
                            uploadBrandingJson(
                              $event,
                              'Logo',
                              'HostInfo',
                              '5/1'
                            )
                          "
                          ref="fuHostLogo"
                          style="display: none"
                        />
                      </div>
                      <div class="logo-edit-butn">
                        <vs-button
                          color="primary"
                          type="filled"
                          v-on:click="$refs.fuHostLogo.click()"
                        >
                          <feather-icon icon="EditIcon" />
                        </vs-button>
                      </div>
                    </div>
                    <div style="text-align: center; padding-top: 5px">
                      <p class="reco-text">High quality image: 960x192px (5:1 ratio)</p>
                    </div>
                  </div>
                  <div class="vx-col md:w-8/12 w-full">
                    <div class="host-name">
                      <label>Host Name</label>
                      <vs-input
                        v-if="BrandingJson.HostInfo"
                        v-model="BrandingJson.HostInfo.Name"
                        class="inputx mt-2 w-full"
                      />
                    </div>
                  </div>
                  <div class="vx-col md:w-1/1 w-full mt-5">
                    <div class="host-desc">
                      <label>Host Short profile</label>
                      <!-- <vs-textarea v-if="BrandingJson.HostInfo"
                        v-model="BrandingJson.HostInfo.Profile"
                        class="host-description-box mt-2"
                      /> -->
                      <ckeditor
                        class="host-description-box mt-2"
                        v-if="BrandingJson.HostInfo"
                        v-model="BrandingJson.HostInfo.Profile"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Features" class="mb-5" icon="feather icon-star">
          <div class="vx-row">
            <div
              class="vx-col sm:w-1/2 w-full mt-5"
              v-for="listItem in Features"
              :key="listItem.ID"
            >
              <div
                class="box-wrap"
                :class="listItem.selected ? 'active-menu-box' : ''"
              >
                <vs-checkbox
                  :disabled="listItem.IsDefault"
                  v-model="listItem.selected"
                  :value="listItem"
                  >{{ listItem.Name }}</vs-checkbox
                >
              </div>
            </div>
          </div>
        </tab-content>

        <template slot="footer" scope="props">
          <div class="wizard-footer-left">
            <vs-button
              v-if="props.activeTabIndex == 0"
              @click.native="$router.push('/event/overview')"
              >Cancel</vs-button
            >
            <vs-button
              v-if="props.activeTabIndex > 0"
              @click.native="props.prevTab()"
              v-else
              >Previous</vs-button
            >
          </div>
          <div class="wizard-footer-right">
            <vs-button
              v-if="!props.isLastStep"
              @click.native="before_save(props.activeTabIndex, true)"
              class="wizard-footer-right ml-4"
              color="success"
              >Save & Continue</vs-button
            >
            <vs-button
              @click.native="before_save(props.activeTabIndex, false)"
              class="wizard-footer-right finish-button ml-4"
              color="success"
              >Save & Exit</vs-button
            >
          </div>
        </template>

        <!-- tab  content -->
      </form-wizard>
    </vx-card>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
/*import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";*/
import CKEditor from "ckeditor4-vue";
import moment from "moment-timezone";
import draggable from "vuedraggable";

import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import moduleLobbyManagement from "@/store/virtuallobby-management/moduleVirtuallobbyManagementActions.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import ls from "@/common/localStorage";
import CKconfig from "@/assets/ckeditor-config.ts";
var cn = ls.getSessionEventCollectionName();
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
var vm;
export default {
  data() {
    return {
      show_adv_settings: false,
      popupActive: false,
      center: { lat: 10.0, lng: 10.0 },
      markers: [
        { position: { lat: 10.0, lng: 10.0 } },
        { position: { lat: 11.0, lng: 11.0 } },
      ],
      locationOptions: [
        { Id: 1, Name: "In-person" },
        { Id: 2, Name: "Virtual" },
        { Id: 3, Name: "Hybrid" },
      ],
      statusOptions: [
        { text: "Plannning", value: "plannning" },
        { text: "In Progress", value: "in progress" },
        { text: "Finished", value: "finished" },
      ],
      LocationOptions: [
        { text: "New York", value: "new-york" },
        { text: "Chicago", value: "chicago" },
        { text: "San Francisco", value: "san-francisco" },
        { text: "Boston", value: "boston" },
      ],
      landingURLOptions: [
        "/lobby",
        "/sessions",
        "/livestage",
        "/stageview",
        "/attendee",
        "/exhibitorshall",
        "/mymeetings",
        "/myprofile",
      ],
      checkBox1: true,
      checkBox2: false,
      checkBox3: true,
      checkBox4: false,
      checkBox5: false,
      checkBox6: false,
      checkBox7: false,
      showRawHtml: false,
      DateDisabled: false,
      configdateTimePickerStart: {
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      EventId: "",
      EventData: null,
      Features: [],
      EventLogoFile: null,
      BackgroundImageFile: null,
      EventBannerFile: null,
      BrandingJson: {
        eventLogo: { "960x192": "", "600x600": "" },
        ogImage: { "1200x628": "" },
        eventBGImage: { "2048x2732": "", "2732x2048": "" },
        banner: {
          "640x88": "",
          "750x103": "",
          "1125x156": "",
          "1242x171": "",
          "1440x176": "",
          "2732x88": "",
          "2048x88": "",
        },
        splashScreenImages: {
          "1125x2436": "",
          "1440x2560": "",
          "2048x2732": "",
          "2732x2048": "",
        },
        headerColorsHexCode: {
          topBar: "#FFFFFF",
          headerBar: "#FFFFFF",
          fontBar: "#000000",
          sideNavigationAndIconColor: "#64656E",
          activeButtonColor: "#ffffff",
          inactiveButtonColor: "#000000"
        },
        appColorHexCodeType: "headerColorsHexCodeLight",
        uploadCustomLogoAndBanner: true,
        headerColorsHexCodeLight: {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
        },
        headerColorsHexCodeDark: {
          cardBackground: "#15191c",
          iconBackground: "#35393d",
          fontColorHeader: "#ffffff",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#272d30",
          tabSelectionColor: "#ffffff",
        },
        headerColorsHexCodeCustom: {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
        },
        Host: {
          Name: "",
          Profile: "",
          Logo: "",
        },
        HostInfo: {
          Name: "",
          Profile: "",
          Logo: "",
        },
      },
      tzStrings: [
        { label: "(GMT-11:00) Midway Island, Samoa", value: "Pacific/Midway" },
        { label: "(GMT-10:00) Hawaii", value: "Pacific/Honolulu" },
        { label: "(GMT-09:00) Alaska", value: "America/Anchorage" },
        {
          label: "(GMT-08:00) Pacific Time (US & Canada)",
          value: "America/Los_Angeles",
        },
        {
          label: "(GMT-08:00) Tijuana, Baja California",
          value: "America/Tijuana",
        },
        { label: "(GMT-07:00) Arizona", value: "America/Phoenix" },
        {
          label: "(GMT-07:00) Mountain Time (US & Canada)",
          value: "America/Denver",
        },
        { label: "(GMT-06:00) Central America", value: "America/Managua" },
        {
          label: "(GMT-06:00) Central Time (US & Canada)",
          value: "America/Chicago",
        },
        {
          label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
          value: "America/Mexico_City",
        },
        { label: "(GMT-06:00) Saskatchewan", value: "America/Regina" },
        {
          label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
          value: "America/Bogota",
        },
        {
          label: "(GMT-05:00) Eastern Time (US & Canada)",
          value: "America/New_York",
        },
        {
          label: "(GMT-04:00) Atlantic Time (Canada)",
          value: "Canada/Atlantic",
        },
        { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
        { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
        { label: "(GMT-03:30) Newfoundland", value: "America/St_Johns" },
        { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
        {
          label: "(GMT-03:00) Buenos Aires, Georgetown",
          value: "America/Argentina/Buenos_Aires",
        },
        { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
        { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
        { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
        { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
        {
          label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
          value: "Africa/Casablanca",
        },
        {
          label: "(GMT+00:00) Coordinated Universal Time",
          value: "UTC",
        },
        {
          label:
            "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
          value: "Etc/Greenwich",
        },
        {
          label: "(GMT+00:00) Western Europe Time, London, Lisbon, Casablanca",
          value: "Europe/London",
        },
        {
          label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
          value: "Europe/Amsterdam",
        },
        {
          label:
            "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
          value: "Europe/Belgrade",
        },
        {
          label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
          value: "Europe/Brussels",
        },
        {
          label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
          value: "CET",
        },
        { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
        {
          label: "(GMT+02:00) Athens, Bucharest, Istanbul",
          value: "Europe/Athens",
        },
        { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
        { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
        { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
        {
          label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
          value: "Europe/Helsinki",
        },
        { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
        { label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "Asia/Kuwait" },
        { label: "(GMT+03:00) Baghdad", value: "Asia/Baghdad" },
        {
          label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
          value: "Europe/Moscow",
        },
        { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
        { label: "(GMT+03:00) Tbilisi", value: "Asia/Baku" },
        { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
        { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
        { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
        { label: "(GMT+04:00) Yerevan", value: "Asia/Baku" },
        { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
        { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
        {
          label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
          value: "Asia/Tashkent",
        },
        {
          label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
          value: "Asia/Calcutta",
        },
        { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
        { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
        { label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "Asia/Bangkok" },
        { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
        {
          label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
          value: "Asia/Hong_Kong",
        },
        { label: "(GMT+08:00) Kuala Lumpur", value: "Asia/Kuala_Lumpur" },
        { label: "(GMT+08:00) Singapore", value: "Asia/Singapore" },
        { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
        { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
        { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
        { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
        { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
        { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
        { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
        { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
        { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
        {
          label: "(GMT+10:00) Canberra, Melbourne, Sydney",
          value: "Australia/Sydney",
        },
        { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
        {
          label: "(GMT+10:00) Guam, Port Moresby",
          value: "Pacific/Port_Moresby",
        },
        { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
        {
          label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
          value: "Asia/Magadan",
        },
        {
          label: "(GMT+12:00) Auckland, Wellington",
          value: "Pacific/Auckland",
        },
        {
          label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
          value: "Pacific/Fiji",
        },
      ],
      PlanDetails: {
        MaxAttendeesPerClient: 10,
        EnhancedEventBranding: false,
        AllowSessionOnDemandVideo: false,
        AllowSessionLiveSimulated: false,
        AllowSessionRoundtable: false,
        ShowBrandingEventSetup: false,
        MaxEventDays: 2,
        EventAccessPostEvent: false,
        EnhancedRegistration: false,
        ContractStartDate: new Date(),
        ContractEndDate: new Date(),
        PricePerExtraAttendee: 100,
      },
      ClientDetails: null,
      navMenuItems: [],
      editorConfig: CKconfig.editorConfig,
      imageRatio: 4 / 3,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "4 / 3",
      popupCropper: false,
      uploadedFile: null,
    };
  },
  watch: {
    /*EventData(){
      this.configdateTimePickerEnd.minDate = new Date(this.EventData.EventStartDate)
      //console.log(this.EventData.EventStartDate)
    }*/
  },
  methods: {
    checkCRMDisable() {
      if (this.EventData.postToCRM === true) {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Are you Sure?",
          text: "This will stop sending Registration data to your CRM",
          acceptText: "OK",
        });
      }
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    onComplete: function () {
      if (this.PlanDetails.ShowBrandingEventSetup) {
        this.formSubmittedt4();
      } else {
        //this.formSubmittedt3()
      }
    },

    mapClicked() {},
    before_save(tabIndex, form_continue = false) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
          if (result) {
            if (tabIndex == 1) {
              vm.formSubmittedt3().then(function () {
                vm.$router.push("/event/overview/");
              });
            } else if (tabIndex == 0 && form_continue) {
              vm.formSubmitted().then(function () {
                vm.$refs.forwizard.nextTab();
              });
            } else if (tabIndex == 0 && !form_continue) {
              vm.formSubmitted().then(function () {
                vm.$router.push("/event/overview/");
              });
            }
          }
        });
      });
    },
    openUploader(fuId) {
      this.$("#" + fuId).trigger("click");
    },
    deleteBrandingJson(input, filename, filesrc) {
      if (confirm("Image will be deleted!")) {
        let clientId = this.$route.params.clientId;
        this.$vs.loading();
        this.$store
          .dispatch("eventManagement/deleteBrandingJson", {
            filename: filename,
            brandingJson: this.BrandingJson,
            updateField: filesrc,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Branding",
              text: "Deleted with image size: " + filename,
            });
            this.BrandingJson[filesrc][filename] = "";
            if (
              filesrc.toLowerCase() === "eventlogo" &&
              filename.toLowerCase() === "960x192"
            ) {
              this.EventData.EventLogo = "";
            }
            if (
              filesrc.toLowerCase() === "eventbgimage" &&
              filename.toLowerCase() === "2732x2048"
            ) {
              this.EventData.BackgroundImage = "";
            }
            if (
              filesrc.toLowerCase() === "banner" &&
              filename.toLowerCase() === "2048x88"
            ) {
              this.EventData.EventBanner = "";
            }
            if (
              filesrc.toLowerCase() === "hostinfo" &&
              filename.toLowerCase() === "logo"
            ) {
              this.EventData.HostInfo = "";
            }
            if (
              filesrc.toLowerCase() === "ogimage" &&
              filename.toLowerCase() === "1200x628"
            ) {
              this.EventData.EventBannerShare = "";
            }
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }
    },
    croppedImagePath(blob) {
      vm.popupCropper = false;
      if (this.uploadedFile) {
        this.uploadFile(
          blob,
          this.uploadedFile.filename,
          this.uploadedFile.filesrc,
          this.uploadedFile.extension
        );
      }
      this.uploadedFile = null;
    },
    uploadBrandingJson(input, filename, filesrc, dimensionCrop) {
      //alert("uploadBrandingJson:" + filename);
      //console.log(filename + filesrc)
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        let extension = file.name.split(".");
        this.uploadedFile = {
          filename: filename,
          filesrc: filesrc,
          extension: extension[1],
        };
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = [];
        if (filesrc.toLowerCase() === "hostinfo") {
          dimension = [960, 192];
        } else {
          dimension = filename.split("x");
        }
        //let dimension = filename.split("x");
        const reader = new FileReader();
        let dimensionCropArr = dimensionCrop.split("/");
        reader.onload = (e) => {
          //vm.BrandingJson[filesrc][filename] = e.target.result;
          vm.resetCropper += 1;
          vm.cropImageUrl = null;
          vm.cropImageUrl = e.target.result;
          vm.imageRatio = dimensionCropArr[0] / dimensionCropArr[1];
          vm.displayImageRatio = dimensionCrop;
          vm.popupCropper = true;
        };
        reader.readAsDataURL(file);
      }
    },
    uploadFile(blob, filename, filesrc, extension) {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadBrandingJsonBlob", {
          blob: blob,
          extension: extension,
          filename: filename,
          brandingJson: this.BrandingJson,
          updateField: filesrc,
        })
        .then((res) => {
          vm.BrandingJson[filesrc][filename] = res.uploadedFileUrl;
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "Updated with image size: " + filename,
          });
          this.$vs.loading.close();
          if (
            filesrc.toLowerCase() === "eventlogo" &&
            filename.toLowerCase() === "960x192"
          ) {
            this.EventData.EventLogo = res.uploadedFileUrl;
          }
          if (
            filesrc.toLowerCase() === "eventbgimage" &&
            filename.toLowerCase() === "2732x2048"
          ) {
            this.EventData.BackgroundImage = res.uploadedFileUrl;
          }
          if (
            filesrc.toLowerCase() === "banner" &&
            filename.toLowerCase() === "2048x88"
          ) {
            this.EventData.EventBanner = res.uploadedFileUrl;
          }
          if (
            filesrc.toLowerCase() === "hostinfo" &&
            filename.toLowerCase() === "logo"
          ) {
            this.EventData.HostInfo = res.uploadedFileUrl;
          }
          if (
            filesrc.toLowerCase() === "ogimage" &&
            filename.toLowerCase() === "1200x628"
          ) {
            this.EventData.EventBannerShare = res.uploadedFileUrl;
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    async update_metaimage(input) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        let imgurl = await this.uploadImage(file);
        if(imgurl) this.EventData.MetaImage = imgurl;
      }
    },
    uploadImage(file){
      this.$vs.loading();
       return new Promise((resolve, reject) => {
        this.$store.dispatch("eventManagement/uploadImage", { path: cn + '/Branding/', file: file }).then((res) => {
          this.$vs.loading.close();
          if(res)
          {
            resolve(res);            
          }
          else
          {
            this.$vs.notify({
                color: "warning",
                position: "top-center",
                //title: "Session",
                text: "File not uploaded!",
              });
            resolve(null);
          }
        }).catch(err=>{ 
          this.$vs.loading.close(); 
          this.$vs.notify({
                color: "warning",
                position: "top-center",
                //title: "Session",
                text: "Something went wrong!",
              });
          resolve(null);
        })
      });
    },
    update_eventlogo(input) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.EventData.EventLogoFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.EventLogoFile = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    update_backgroundimage(input) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.EventData.BackgroundImageFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.BackgroundImageFile = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    update_eventbanner(input) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.EventData.EventBannerFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.EventBannerFile = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    formSubmittedt3() {
      this.$vs.loading();
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("eventManagement/updateEventFeatures", {
            SelectedFeatures: this.Features,
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Features",
              text: "Features Updated",
            });
            this.navMenuItems = navMenuItems.getMenus();
            this.$root.$emit("updatenavMenuItems", this.navMenuItems);
            this.$vs.loading.close();
            resolve(true);

            //alert("VirtualLobbySavedaaaa");
            //this.$store
            //  .dispatch("lobbyManagement/CreateDefaultLobby", {
            //    data: "VirtualLobby",
            //  })
            //  .then((res) => {
            //    alert("VirtualLobbySaved");
            //  })
            //  .catch((err) => {
            //    //console.error(err)
            //    this.$vs.loading.close();
            //    resolve(false);
            //  });
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
            resolve(false);
          });
      });
    },
    formSubmittedt4() {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadBrandingJsonColor", {
          brandingJson: this.BrandingJson,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "JSON updated",
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            //this.$router.push('/event/list');
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    formSubmitted() {
      //console.log(this.EventData)
      //alert("Form submitted!");
      var language =
        this.EventData.DefaultLanguage != null
          ? this.EventData.DefaultLanguage
          : "English";
      let info = {
        Session_Event_Theme: this.BrandingJson.appColorHexCodeType,
        Sesion_StreamingClient: this.EventData.StreamingClient,
        Sesion_ApprovalType: this.EventData.approval_type,
        Sesion_EventAccessType: this.EventData.EventAccessType,
        Default_Event_Language: language,
      };
      ls.setSessionUserInfo(info);

      this.EventData.StartDateTZ = moment(this.EventData.EventStartDate).format(
        "MMM DD, YYYY"
      );
      this.EventData.StartTimeTZ = moment(this.EventData.EventStartDate).format(
        "hh:mm A"
      );
      this.EventData.EndDateTZ = moment(this.EventData.EventEndDate).format(
        "MMM DD, YYYY"
      );
      this.EventData.EndTimeTZ = moment(this.EventData.EventEndDate).format(
        "hh:mm A"
      );

      this.EventData.StartDate = this.GetTimeByZone(
        this.EventData.EventStartDate,
        this.EventData.TimeZone
      );
      this.EventData.EndDate = this.GetTimeByZone(
        this.EventData.EventEndDate,
        this.EventData.TimeZone
      );
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$vs.loading();
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("eventManagement/updateEvent", {
            id: Session_Event_Id,
            data: this.EventData,
            brandingJson: this.BrandingJson,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Event",
              text: res.message,
            });
            this.EventData.BackgroundImageFile = null;
            this.EventData.EventBannerFile = null;
            this.EventData.EventLogoFile = null;
            this.$vs.loading.close();
            this.fetchBrandingJson();
            resolve(true);
          });
      });
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    async fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          this.EventData = res.data;
          this.EventData.EventStartDate = this.SetTimeByZone(
            res.data.EventStartDate,
            res.data.TimeZone
          );
          this.EventData.EventEndDate = this.SetTimeByZone(
            res.data.EventEndDate,
            res.data.TimeZone
          );
          ls.setSessionUserInfo({
            Session_EventStartDate: this.EventData.EventStartDate,
            Session_EventEndDate: this.EventData.EventEndDate,
            Session_Event_TZ: this.EventData.TimeZone,
          });
          let checkCurrentDate = this.SetTimeByZone(
            new Date().toUTCString(),
            this.EventData.TimeZone
          );
          this.configdateTimePickerStart.minDate = new Date(checkCurrentDate);
          this.configdateTimePickerEnd.minDate = new Date(
            this.EventData.EventStartDate
          );
          if (
            new Date(this.EventData.EventStartDate).getTime() <=
            new Date(checkCurrentDate).getTime()
          ) {
            this.configdateTimePickerStart.minDate = new Date(
              this.EventData.EventStartDate
            );
            this.configdateTimePickerStart.maxDate = new Date(
              this.EventData.EventStartDate
            );
            this.DateDisabled = true;
          }

          if (
            new Date(this.EventData.EventEndDate).getTime() <
            new Date(checkCurrentDate).getTime()
          ) {
            this.configdateTimePickerEnd.maxDate = new Date(
              this.EventData.EventEndDate
            );
          }
          this.EventData.EventBannerShare = res.data.EventBannerShare ? res.data.EventBannerShare : null;
          this.EventLogoFile = res.data.EventLogo;
          this.BackgroundImageFile = res.data.BackgroundImage;
          this.EventBannerFile = res.data.EventBanner;
          this.EventData.DefaultLanguage =
            res.data.DefaultLanguage != null
              ? res.data.DefaultLanguage
              : "English";
        })
        .catch((err) => {});

      this.$store
        .dispatch("eventManagement/fetchEventFeatures", Session_Event_Id)
        .then((res) => {
          this.Features = res.AllFeatures ? res.AllFeatures : [];
        });

      await this.fetchBrandingJson();
    },
    fetchBrandingJson() {
      this.$store
        .dispatch("eventManagement/fetchBrandingJson")
        .then((res) => {
          //let obj = JSON.parse(res)
          //console.log(res.eventLogo)
          //console.log(res.eventLogo["960x192"])
          if (res) {
            vm.BrandingJson = res;
            let info = {
              Session_Event_Theme: res.appColorHexCodeType,
            };
            ls.setSessionUserInfo(info);

            if (res.headerColorsHexCodeLight) {
            } else {
              vm.BrandingJson.headerColorsHexCodeLight = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
              };
            }

            if (res.headerColorsHexCodeDark) {
            } else {
              vm.BrandingJson.headerColorsHexCodeDark = {
                cardBackground: "#15191c",
                iconBackground: "#35393d",
                fontColorHeader: "#ffffff",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#272d30",
                tabSelectionColor: "#ffffff",
              };
            }

            if (res.headerColorsHexCodeCustom) {
            } else {
              vm.BrandingJson.headerColorsHexCodeCustom = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
              };
            }
            if (res.appColorHexCodeType) {
            } else {
              
              vm.BrandingJson.appColorHexCodeType = "headerColorsHexCodeLight";
              brandingJson.webColorHexCodeType = "headerColorsHexCodeLight";

              vm.BrandingJson.headerColorsHexCodeLight = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
              };
              vm.BrandingJson.headerColorsHexCodeDark = {
                cardBackground: "#15191c",
                iconBackground: "#35393d",
                fontColorHeader: "#ffffff",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#272d30",
                tabSelectionColor: "#ffffff",
              };
              vm.BrandingJson.headerColorsHexCodeCustom = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
              };
            }
            if (res.eventLogo != undefined) {
              if (res.eventLogo["960x192"] != undefined) {
                vm.EventLogo = res.eventLogo["960x192"];
              }
            }else{
              vm.BrandingJson.eventLogo = { "960x192": "", "600x600": "" }
            }       
            if (res.eventBGImage != undefined) {
              if (res.eventBGImage["2732x2048"] != undefined) {
                vm.BackgroundImage = res.eventBGImage["2732x2048"];
              }
            }
            if (res.banner != undefined) {
              if (res.banner["2048x88"] != undefined) {
                vm.EventBanner = res.banner["2048x88"];
              }
            }
            if (res.uploadCustomLogoAndBanner == undefined) {
              vm.BrandingJson.uploadCustomLogoAndBanner = true;
            } else {
              vm.BrandingJson.uploadCustomLogoAndBanner =
                res.uploadCustomLogoAndBanner;
            }
            if (vm.BrandingJson.HostInfo == undefined) {
              vm.BrandingJson.HostInfo = {
                Name: "",
                Profile: "",
                Logo: "",
              };
            }
            if (res.HostInfo == undefined) {
              vm.BrandingJson.HostInfo.Name = "";
              vm.BrandingJson.HostInfo.Profile = "";
              vm.BrandingJson.HostInfo.Logo = "";
            } else {
              vm.BrandingJson.HostInfo.Name =
                res.HostInfo.Name == undefined ? "" : res.HostInfo.Name;
              vm.BrandingJson.HostInfo.Profile =
                res.HostInfo.Profile == undefined ? "" : res.HostInfo.Profile;
              vm.BrandingJson.HostInfo.Logo =
                res.HostInfo.Logo == undefined ? "" : res.HostInfo.Logo;
            }

            if (res.ogImage == undefined) {              
                vm.BrandingJson.ogImage = { "1200x628": "" };
            }
            //vm.eventLogo = res.eventLogo;
            //vm.eventBGImage = res.eventBGImage;
            //vm.banner = res.banner;
            //vm.splashScreenImages =  res.splashScreenImages;
            //vm.headerColorsHexCode =  res.headerColorsHexCode;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchClientPlanDetails() {
      this.$store
        .dispatch("clientManagement/fetchClientPlanDetails", Session_Client_Id)
        .then((res) => {
          if (res.PlanDetails) {
            this.PlanDetails = res.PlanDetails;
          }
        });
    },
    fetchClient() {
      this.$store
        .dispatch("clientManagement/fetchClient", Session_Client_Id)
        .then((res) => {
          if (res.status == 200) {
            this.ClientDetails = res.data;
            this.EventData.postToCRM = res.data.crm_integration && res.data.crm_integration
              .IsPublished
              ? this.EventData.postToCRM
              : false;
          }
        });
    },
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    draggable,
    flatPickr,
    vSelect,
    //quillEditor,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
  },
  // updated() {
  //   let currentUrl = window.location.href;
  //   let currentUrlSplit = currentUrl.split("#");
  //   if (currentUrlSplit && currentUrlSplit[1]) {
  //     let divId = currentUrlSplit[1];
  //     let div = document.getElementById(divId);
  //     let pos = div.getBoundingClientRect();
  //     window.scrollTo(0, pos.top);
  //   }
  // },
  mounted() {
    vm = this;
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetch_event_data();
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClientPlanDetails();
    this.fetchClient();

    if (!moduleLobbyManagement.isRegistered) {
      this.$store.registerModule("lobbyManagement", moduleLobbyManagement);
      moduleLobbyManagement.isRegistered = true;
    }
    setTimeout(function () {
      if(location.href.includes('#apply_theme')){
              var element = document.getElementById("apply_theme");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
      }
    }, 3500);

    /*navMenuItems.cn = ls.getSessionEventCollectionName()
    this.navMenuItems = navMenuItems.getMenus()    
    this.$root.$emit('updatenavMenuItems', this.navMenuItems)
    this.$root.$emit('Set_header_Session_Event_FullName', ls.getSessionValueByKey('Session_Event_FullName') )*/
  },
  watch: {
    "EventData.EventType"(val) {
      if (val == 1) {
        this.EventData.AllowRegistration = false;
      }
    },
  },
};
</script>